import type {Item,Snapshot} from './model'
export function screensArtifact(item:Item,data:Snapshot|undefined,requested?:string|null){
 const jobs=(data?.jobs??[]).filter(j=>j.task_id===item.task_id&&j.kind==='screens'&&j.state==='succeeded').sort((a,b)=>b.created_at.localeCompare(a.created_at)||b.id.localeCompare(a.id))
 for(const job of jobs){const file=data?.outputs.find(o=>o.job_id===job.id&&o.name==='screens.html'&&(!requested||o.id===requested));if(file)return file}
 return undefined
}
